import React from 'react';
import BatteryIndicator from './BatteryIndicator';
import styles from './Devices.module.scss';

interface DeviceCellProps {
  /** The device's module ID — the row's identifier for it. */
  moduleId: string;
  /** Customer-facing model name, e.g. "Fi Series 3". */
  type: string;
  /**
   * Show the battery reading stacked under the model. Off by default: only the tables that
   * used to carry a Battery column show one, and a `null` battery still earns its line
   * there (it reads "no reading", which is different from "we don't report this here").
   */
  showBattery?: boolean;
  battery?: number | null;
}

/**
 * The Device column's contents, shared by every table on the Devices page so a device
 * renders identically wherever it appears.
 *
 * The battery reading lives here rather than in a column of its own: on its own line at the
 * foot of the cell it costs the column no width, which is what lets these tables spend
 * their horizontal space on data instead.
 */
export default function DeviceCell({ moduleId, type, showBattery = false, battery = null }: DeviceCellProps) {
  return (
    <>
      <div className={styles.deviceId}>{moduleId}</div>
      <div className={styles.deviceType}>{type}</div>
      {showBattery && (
        <div className={styles.deviceBattery}>
          <BatteryIndicator battery={battery} />
        </div>
      )}
    </>
  );
}
